























import { IAddress } from "@/store/types";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({})
export default class Addresses extends Vue {
    @State("addresses")
    public addresses: IAddress[];

    public getAddress(address: IAddress) : string {
        return address.postal_code + ", "
            + address.city + ", "
            + address.street + " "
            + address.number;
    }
}
